import React from "react";
import {
  IonButton, IonSpinner, IonModal, IonToolbar, IonTitle, IonButtons, IonHeader,
  IonContent, IonIcon
} from "@ionic/react";
import {addCircle} from "ionicons/icons";
import localForage from "localforage";
import {FazendaObject} from "../../models/Fazenda";
import {post, get} from "../../utils/frRequest";
import {debug} from "../../config";
import Calendario from "./Calendario";
import CalendarioInstance from "./Calendario/CalendarioInstance";
import moment from 'moment';
import {AppState} from "../../models/app";
import {AppDispatch, RootState} from "../../global.state";
import {connect} from "react-redux";
import {actions} from "../../lib/app";


interface Props {
  app: AppState;
  dispatch: AppDispatch;
  instance: FazendaObject;
}

interface State {
  existe: boolean;
  loading: boolean;
  loaded: boolean;
  erroFatal: boolean;

  // simulacao
  calendario: any[];
  rebanho: any[];
  produtos: any[];
  // data: moment.Moment | undefined;
  created_at: moment.Moment | undefined;
  updated_at: moment.Moment | undefined;

  // modal calendario
  modalIsOpen: boolean;
}

class _AbaCalendario extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      existe: false,
      loading: false,
      loaded: false,
      erroFatal: false,

      calendario: [],
      rebanho: [],
      produtos: [],
      created_at: undefined,
      updated_at: undefined,

      modalIsOpen: false,
    };
  }

  componentDidMount() {
    // validar acesso
    const frAccessAuthorized = this.props.app.frAccessAuthorized;

    if (!this.props.app.online)
      return;

    if (frAccessAuthorized) {
      // console.log('CHAMANDO loadCalendario via componentDidMount');
      this.loadCalendario();
    } else {
      this.autorizarAcesso();
    }
  }

  componentDidUpdate(prevProps:Props, prevState:State) {
    if (!this.props.app.online)
      return;

    if (this.props.app.frAccessAuthorized) {
      if (!this.state.loading && !this.state.loaded && !this.state.erroFatal) {
        // load
        // console.log('CHAMANDO loadCalendario via componentDidUpdate');
        this.loadCalendario();
      }
    }

    if (prevProps.instance.id !== this.props.instance.id) {
      // console.log('RESET STATE via componentDidUpdate');
      this.setState({
        loading: false,
        loaded: false,
      });
    }
  }

  autorizarAcesso = async () => {
    // console.log('autorizarAcesso');
    this.setState({erroFatal: false, loading: true, loaded: false});

    const {success, data, error} = await post('/veApi/authorize_access',
      {uid: this.props.app.user.uid, type: 'vet_experts'});

    if (!success) {
      console.log(`authorize_access error: ${error}`);
      this.props.dispatch(actions.notifyError('Erro autorizando acesso Fazenda Rentável.'));
      this.setState({erroFatal: true, loading: false});
      return;
    }

    // authorization data
    await localForage.setItem('frAccess', data);
    this.props.dispatch(actions.setFrAccessAuthorized(true));
    this.setState({loading: false});
  }

  loadCalendario = async () => {
    debug('loadCalendario', `Carregando calendario ${this.props.instance.id}`);

    this.setState({loading: true, loaded: false});

    const {success, data, error} = await post('/veApi/vet_experts/load_calendario',
      {fazendaId: this.props.instance.id});

      if (!success) {
        if (error.match(/Access denied/)) {
          // resetar token e reautorizar
          await localForage.removeItem('frAccess');
          this.props.dispatch(actions.setFrAccessAuthorized(false));
          return this.autorizarAcesso();
        }

        this.props.dispatch(actions.notifyError(error));
        this.setState({loading: false, erroFatal: true});
        return;
      }

      const state: any = {
        loaded: true,
        loading: false,
        existe: false,
      };

      if (data.calendario) {
        state.existe = true;
        state.produtos = data.calendario.produtos;
        state.rebanho = data.calendario.rebanho;
        state.calendario = data.calendario.calendario;
        state.created_at = moment(data.calendario.created_at);
        state.updated_at = moment(data.calendario.updated_at);
      }

      this.setState(state);
  };

  novoCalendario = () => {
    // load todos os dados necessarios
    get('/veApi/vet_experts/load_defaults')
      .then(({success, error}) => {
        if (!success) {
          console.error(`Erro inesperado em load_defaults: ${error}`);
          this.props.dispatch(actions.notifyError('Erro carregando dados para iniciar o calendário!'));
          return;
        }

        this.setState({modalIsOpen: true});
      });

  };

  onConcluir = () => {
    this.props.dispatch(actions.notifySuccess('Calendário preparado com sucesso!'));
    this.setState({modalIsOpen: false}, () => {
      // esperar pop fechar antes de carregar o calendario
      setTimeout(() => {
        this.loadCalendario();
      }, 500);
    });
  };

  render() {
    // offline
    if (!this.props.app.online) {
      return (
        <div className="flex items-center w-full h-full justify-center">
          <div className="text-center m-8">
            <div>
              Você precisa estar online para ter acesso aos recursos do
              Calendário Sanitário.
            </div>
          </div>
        </div>
      );
    }

    // erro
    if (this.state.erroFatal) {
      return (
        <div className="flex items-center w-full h-full justify-center">
          <div className="text-center m-8">
            <div>
              Ocorreu um erro inesperado na comunicação com o Fazenda Rentável, necessário
              para o acesso ao calendário sanitário.
            </div>
            <div className="mt-4">
              Tente novamente em alguns instantes.
            </div>
          </div>
        </div>
      );
    }

    // com calendario
    return (
      <>
        {this.state.loading &&
          <div className="flex items-center w-full h-full justify-center">
            <div className="text-center m-8">
              <div>
                <IonSpinner/>
              </div>
            </div>
          </div>
        }
        {this.state.loaded &&
          <>
            {this.state.existe &&
              <CalendarioInstance
                fazenda={this.props.instance}
                produtos={this.state.produtos}
                rebanho={this.state.rebanho}
                calendario={this.state.calendario}
                created_at={this.state.created_at!}
                updated_at={this.state.updated_at!}
                setEdit={() => this.setState({modalIsOpen: true})}
              />
            }
            {!this.state.existe &&
              <div className="flex items-center w-full h-full justify-center">
                <div className="text-center m-8">
                  <div>
                    Esta fazenda ainda não tem um calendário sanitário definido.
                  </div>
                  <IonButton
                    className="mt-4"
                    onClick={this.novoCalendario}
                  >
                    <IonIcon icon={addCircle} slot={'start'}/>
                    Adicionar
                  </IonButton>
                </div>
              </div>
            }
          </>
        }

        <IonModal
          isOpen={this.state.modalIsOpen}
          onDidDismiss={() => this.setState({modalIsOpen: false})}
        >
          <IonHeader>
            <IonToolbar>
              <IonTitle>
                Calendário sanitário
              </IonTitle>
              <IonButtons slot="end">
                <IonButton
                  onClick={() => this.setState({modalIsOpen: false})}
                >
                  Fechar
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>

          <IonContent className="ion-padding">
            <Calendario
              fazenda={this.props.instance}
              onConcluir={this.onConcluir}
              produtos={this.state.produtos}
              rebanho={this.state.rebanho}
              calendario={this.state.calendario}
            />
          </IonContent>
        </IonModal>
      </>
    );
  }
}

export const AbaCalendario = connect(({app}: RootState) => ({app}))(_AbaCalendario);